// FIFO async mutex. Holders must release in a finally, or a thrown body deadlocks the lock.

export class Mutex {
  private locked = false;
  private readonly waiters: Array<() => void> = [];

  async acquire(): Promise<() => void> {
    if (!this.locked) {
      this.locked = true;
      return this.makeRelease();
    }
    await new Promise<void>((resolve) => { this.waiters.push(resolve); });
    return this.makeRelease();
  }

  async runExclusive<T>(fn: () => Promise<T>): Promise<T> {
    const release = await this.acquire();
    try { return await fn(); }
    finally { release(); }
  }

  private makeRelease(): () => void {
    let released = false;
    return () => {
      if (released) return;
      released = true;
      const next = this.waiters.shift();
      if (next === undefined) {
        this.locked = false;
      } else {
        next();
      }
    };
  }
}
